<template>
  <div class="gekko-logo-anim">
    <span class="sr-only">Gekko</span>
    <lottie :class="color" :options="animationOptions" @animCreated="handleAnimation" />
  </div>
</template>

<script>
import lottie from 'vue-lottie/src/lottie.vue'
import * as logoAnimation from '@/css/animations/logo-brand.json';

export default {
  components: {
    lottie
  },
  props: {
    theme: {
      type: String,
      default: 'brand'
    }
  },
  data () {
    return {
      animationOptions: {
        animationData: logoAnimation.default,
        loop: false,
        autoplay: false
      },
      random: { min: 2000, max: 5000 },
      anim: null
    }
  },
  computed: {
    color () {
      return (this.theme === 'brand') ? 'text-brand' : 'text-white'
    }
  },
  methods: {
    handleAnimation (anim) {
      this.anim = anim
      this.playAnimation()
    },
    playAnimation () {
      this.anim.goToAndPlay(0)
      const animationWait = this.random.min + Math.random() * (this.random.max - this.random.min)
      setTimeout(() => {
        this.playAnimation()
      }, animationWait)
    }
  }
}
</script>

<style lang="scss">
  .gekko-logo-anim {
    width: 100px;
    height: auto;
    svg {
      fill: currentColor;
    }
  } 
</style>
